<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import themeConfig from '@/../themeConfig.js';
import locale from './locale';
import {
  updateStoreDataEmpresa,
} from './services/multiple-empresa';
// REMOVIDO TEMPORARIAMENTE
// import serviceStatusNotification from './services/statusNotification';
import setUpCustomValidations from './validation.js';

export default {
  data() {
    return {
      execWatchRoute: false,
    };
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    $route(to) {
      if (this.execWatchRoute) {
        return;
      }

      const allowedRoutes = [
        'boleto',
        'contratoProposta',
        'laudoVistoria',
        'novaPropostaUser',
        'painelAssistencia',
        'propostaBP',
      ];

      if (!allowedRoutes.includes(to.name)) {
        //@Alternar empresa 117 para 118
        this.alternaEmpresa();
      }

      // REMOVIDO TEMPORARIAMENTE
      // serviceStatusNotification.getCountBadges();

      this.execWatchRoute = true;
    },
  },
  async created() {
    try {
      this.$validator.localize('ptBr', locale);
      setUpCustomValidations();
      updateStoreDataEmpresa();

      await this.$auth.renewTokens();
    } catch (e) {}
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
    alternaEmpresa() {
      const userToken = localStorage.getItem('user-token');
      if (userToken) {
        const { id_empresa } = jwt.decode(userToken);

        if (id_empresa && id_empresa === 117) {
          this.$router.replace('/Login?idEmpresa=118');
        }
      }
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
};
</script>

<style>
input.has-error,
div.has-error.vs-input input,
div.has-error.v-select {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
  border-radius: 5px;
}
div.has-error.v-select .vs__dropdown-toggle {
  border: 0px !important;
}
</style>
